module.exports = __webpack_public_path__ + "img/COMBO PALM PURPLE.b7e3e44.svg";